import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    backgroundColor: theme.palette.brand.white,
    justifyContent: 'center',
    textAlign: 'center',
    alignSelf: 'center',
    padding: theme.spacing(1.5),
    maxWidth: 750,
  },
  questions: {
    display: 'inline-block',
  },
  contentBelowButtons: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
}));
